var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36872 1.47982C4.23228 1.33814 4.04065 1.25 3.82843 1.25C3.6163 1.25 3.42473 1.33807 3.28831 1.47964L0.46967 4.29828C0.176777 4.59118 0.176777 5.06605 0.46967 5.35894C0.762563 5.65184 1.23744 5.65184 1.53033 5.35894L3.07843 3.81084L3.07843 14C3.07843 14.4142 3.41422 14.75 3.82843 14.75C4.24264 14.75 4.57843 14.4142 4.57843 14L4.57843 3.81085L6.12652 5.35894C6.41942 5.65184 6.89429 5.65184 7.18718 5.35894C7.48008 5.06605 7.48008 4.59118 7.18718 4.29828L4.36872 1.47982ZM11.4184 12.1892L9.87033 10.6411C9.57743 10.3482 9.10256 10.3482 8.80967 10.6411C8.51677 10.934 8.51677 11.4088 8.80967 11.7017L11.6281 14.5202C11.7646 14.6618 11.9562 14.75 12.1684 14.75C12.3806 14.75 12.5721 14.6619 12.7086 14.5203L15.5272 11.7017C15.8201 11.4088 15.8201 10.9339 15.5272 10.6411C15.2343 10.3482 14.7594 10.3482 14.4665 10.6411L12.9184 12.1892L12.9184 2C12.9184 1.58579 12.5826 1.25 12.1684 1.25C11.7542 1.25 11.4184 1.58579 11.4184 2L11.4184 12.1892Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.c28dfab0a11340c70d1ee05f7dd2edd7.svg";
export { ForwardRef as ReactComponent };